import { HoldingClass } from 'types/HoldingClass';

import {
  SharesTransferExcelValidationError,
} from '../types/SharesTransferExcel';

type ResolveHoldingClassResult =
  | {
      holdingClassId: string;
      holdingClassName: string;
      error: null;
    }
  | {
      holdingClassId: null;
      holdingClassName: null;
      error: SharesTransferExcelValidationError;
    };

export const resolveHoldingClassForExcel = (
  holdingClasses: HoldingClass[]
): ResolveHoldingClassResult => {
  if (!holdingClasses?.length) {
    return {
      holdingClassId: null,
      holdingClassName: null,
      error: { code: 'NO_HOLDING_CLASS' },
    };
  }

  if (holdingClasses.length === 1) {
    return {
      holdingClassId: holdingClasses[0]._id,
      holdingClassName: holdingClasses[0].name,
      error: null,
    };
  }

  return {
    holdingClassId: null,
    holdingClassName: null,
    error: { code: 'AMBIGUOUS_HOLDING_CLASS' },
  };
};
